// React
import React from 'react'
import stringify from 'json-stable-stringify'
// GraphQL
import { graphql } from 'react-apollo'
// GraphQL queries
import { contactQuery } from '../../graphql/queries/contacts'
// GraphQL subscriptions
import { contactSubscription } from '../../graphql/subscriptions/contacts'
// Functions
import compatibility from '../../functions/relationship'
// Components
import Button from '../Display/Button'
import Item from '../Display/Item'
import Loading from '../Display/Loading'
import Logo from '../Display/Logo'
import Modal from '../Display/Modal'
import PersonalInfo from '../Pages/PersonalInfo'
import Social from '../Display/Social'
import Tab from './Tab'


class Relationships extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			contacts: [],
			modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null }, loading: false }
		}
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.data.loading) {
			// LOCAL STATE
			const contacts = nextProps.data.contactQuery.map((contact, contactIndex) => {
				const { id, nameFirst, nameLast, birthDate, birthPlace, birthTime, birthSigns } = contact
				return { id, nameFirst, nameLast, birthDate, birthPlace, birthTime, birthSigns }
			})
			// Update local state
			if (stringify(this.state.contacts) !== stringify(contacts)) {
				this.setState({ contacts })
			}
			// CONTACT SUBSCRIPTION
			this.contactSubscription = nextProps.data.subscribeToMore({
				document: contactSubscription,
				variables: { userId: this.props.user.id },
				updateQuery: (previousState, { subscriptionData }) => nextProps.data.refetch(),
				onError: (err) => console.error(err)
			})
		}
	}

	render() {
		if (this.props.data.loading) {
			return <Loading status={true} text='loading...' />
		}
		if (!this.props.user.birthSigns) {
			return <PersonalInfo {...this.props} />
		}
		const { addPage } = this.props.redux.nav
		const { contacts, modal } = this.state
		return (
			<div>
				<Modal
					status={modal.status}
					title={modal.title}
					text={modal.text}
					action={{ text: modal.action.text, func: modal.action.func }}
					cancel={{ text: modal.cancel.text, func: modal.cancel.func }}
					loading={modal.loading}
				/>
				<Logo {...this.props} />
				<Tab {...this.props} />
				<div className='capps-container'>
					<Button
						action={() => setTimeout(() => addPage('add'), 20)}
						text='Add a new relationship'
					/>
					<div className='capps-height-10' />
					<div className='capps-footer' onTouchTap={() => {
						setTimeout(() => {
							window.localStorage.setItem('MoonSignApp:colorScale', true)
							this.props.redux.nav.setPage('relationships')
						}, 20)
					}}>
						<span className='capps-link'>Color scale</span>
					</div>
					<div className='capps-height-10' />
					{contacts.map((contact, contactIndex) => (
						<Item
							key={contactIndex}
							top={contactIndex === 0}
							bottom={contactIndex === contacts.length - 1}
							action={() => setTimeout(() => addPage('contact', { contact }), 20)}
							icon=''
							text={contact.nameFirst + ' ' + contact.nameLast}
							sign={contact.birthSigns.moon.name}
							color={compatibility(this.props.user.birthSigns.moon.name, contact.birthSigns.moon.name).color}
						/>
					))}
				</div>
				<Social />
			</div>
		)
	}

}

export default
	graphql(contactQuery, {
		options: ({ user }) => ({ variables: { contactFilter: { user: { id: user.id } } } })
	})(Relationships)



// WEBPACK FOOTER //
// ./src/Components/Home/Relationships.js